import { StyleSheet } from 'react-native';

export default StyleSheet.create({
    regular: {
        fontFamily: 'Comfortaa-Regular',
    },
    bold: {
        fontFamily: 'Comfortaa-Bold',
    },
    form: {
        backgroundColor: 'white',
        marginBottom: 25
      },
    formContainer: {
        paddingHorizontal: 15,
        paddingVertical: 20,
        flex: 1
      },
      formTitle: {
        color: '#461b6f',
        textAlign: 'center',
        padding: 12,
        fontSize: 16
      },
      formSubtitle: {
        color: '#461b6f',
        textDecorationLine: 'underline'
      },
      formRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 10
      },
      formTextareaRow: {
        marginBottom: 10
      },
      doubleInput: {
        display: 'flex',
        flexDirection: 'row',
      },
      secondInput: {
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: 65
      },
      formRowLabel: {
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: 110,
        paddingRight: 10
      },
      formRowInput: {
        flex: 1,
        width: '100%',
      },
      title: {
        color: '#461b6f',
        marginBottom: 3,
        fontSize: 22
      },
      subtitle: {
        marginBottom: 15
      },
      background: {
        flex: 1,
        backgroundColor: '#F6F4F9',
        paddingTop: 15,
        paddingHorizontal: 20,
        paddingBottom: 70,
        overflow: 'scroll'
      },
      button: {
        paddingVertical: 10,
        paddingHorizontal: 30,
        backgroundColor: '#461b6f',
        color: 'white',
        borderRadius: 12,
        textAlign: 'center'
      },
      smallButton: {
        height: 33,
        lineHeight: 30,
        paddingHorizontal: 20,
        borderColor: '#461b6f',
        color: '#461b6f',
        borderWidth: 0.5,
        backgroundColor: 'white',
        borderRadius: 8,
        textAlign: 'center'
      },
      filterButton: {
          marginRight: 10,
          marginBottom: 10,
          flexBasis: 125,
          flexGrow: 0,
          flexShrink: 0
      },
      fullFilterButton: {
          marginRight: 10,
          marginBottom: 10,
          flexBasis: 260,
          flexGrow: 0,
          flexShrink: 0
      },
});